import { render, staticRenderFns } from "./MmodelsView.vue?vue&type=template&id=a6fc9bea&scoped=true"
import script from "./MmodelsView.vue?vue&type=script&lang=js"
export * from "./MmodelsView.vue?vue&type=script&lang=js"
import style0 from "./MmodelsView.vue?vue&type=style&index=0&id=a6fc9bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fc9bea",
  null
  
)

export default component.exports